module.exports = __webpack_public_path__ + "static/img/logo_.cd5cece.png";